import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f23cc21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "heading-layout" }
const _hoisted_4 = { class: "dependent-title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "row-content" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "form-group mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "form-label"
}, "First Name *", -1))
const _hoisted_11 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = { class: "form-group mb-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "form-label"
}, "Last Name *", -1))
const _hoisted_16 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = { class: "form-group mb-3" }
const _hoisted_20 = {
  for: "ssn",
  class: "form-label"
}
const _hoisted_21 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-12" }
const _hoisted_24 = { class: "form-group mb-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "dob",
  class: "form-label"
}, "Date Of Birth *", -1))
const _hoisted_26 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { class: "form-group mb-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "gender",
  class: "form-label"
}, "Gender *", -1))
const _hoisted_31 = { class: "select-box" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Select a Gender", -1))
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "form-group mb-3" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "relationship",
  class: "form-label"
}, "Relationship * ", -1))
const _hoisted_39 = { class: "select-box" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Select a Relationship", -1))
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_43 = { class: "modal-footer" }
const _hoisted_44 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTip = _resolveComponent("ToolTip")!
  const _directive_maska = _resolveDirective("maska")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["modal fade", { 'show d-block': _ctx.visible }]),
        tabindex: "-1"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.modalTitle), 1)
            ]),
            (_ctx.isFormInvalid)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "alert alert-danger",
                  innerHTML: _ctx.validationMsg
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "50",
                      id: "firstName",
                      class: _normalizeClass(["form-control", 
                    _ctx.v$.user.firstName.$error ? 'is-invalid' : 'input-text'
                  ]),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.firstName) = $event)),
                      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideErrors('firstName')))
                    }, null, 34), [
                      [_vModelText, _ctx.user.firstName]
                    ]),
                    (_ctx.v$.user.firstName.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (_ctx.v$.user.firstName.required)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass({ 'is-invalid': _ctx.v$.user.firstName.$error })
                              }, " Please enter a valid first name. ", 2))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      maxlength: "50",
                      type: "text",
                      id: "lastName",
                      class: _normalizeClass(["form-control", _ctx.v$.user.lastName.$error ? 'is-invalid' : 'input-text']),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.lastName) = $event)),
                      onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideErrors('lastName')))
                    }, null, 34), [
                      [_vModelText, _ctx.user.lastName]
                    ]),
                    (_ctx.v$.user.lastName.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_ctx.v$.user.lastName.required)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass({ 'is-invalid': _ctx.v$.user.lastName.$error })
                              }, " Please enter a valid last name. ", 2))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, [
                      _createTextVNode("SSN *"),
                      _createVNode(_component_ToolTip, { tooltipText: "Enter your dependents' SSN." })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "ssn",
                      class: _normalizeClass(["form-control type-number", _ctx.v$.user.ssn.$error ? 'is-invalid' : 'input-text']),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.ssn) = $event)),
                      onKeydown: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideErrors('ssn'))),
                      "data-maska": "*##-##-####"
                    }, null, 34), [
                      [_vModelText, _ctx.user.ssn],
                      [_directive_maska]
                    ]),
                    (_ctx.v$.user.ssn.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (_ctx.v$.user.ssn.required)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass({ 'is-invalid': _ctx.v$.user.ssn.$error })
                              }, " Please enter a valid SSN ", 2))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.dob) = $event)),
                      onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.user.dob.$touch())),
                      class: _normalizeClass({
                    'is-invalid': _ctx.v$.user.dob.$error,
                    'form-control': true,
                  })
                    }, null, 34), [
                      [_vModelText, _ctx.user.dob]
                    ]),
                    (_ctx.v$.user.dob.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          (_ctx.v$.user.dob.required)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass({ 'is-invalid': _ctx.v$.user.dob.$error })
                              }, " Please enter a valid Date of Birth between 1/1/1753 and " + _toDisplayString(new Date().toLocaleDateString()), 3))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, [
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["form-control", _ctx.v$.user.gender.$error ? 'is-invalid' : 'input-text']),
                        id: "gender",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.gender) = $event)),
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hideErrors('gender')))
                      }, [
                        _hoisted_32,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderData, (gender) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: gender.genderId,
                            value: gender.genderId
                          }, _toDisplayString(gender.genderName), 9, _hoisted_33))
                        }), 128))
                      ], 34), [
                        [_vModelSelect, _ctx.user.gender]
                      ])
                    ]),
                    (_ctx.v$.user.gender.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          (_ctx.v$.user.gender.required)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass({ 'is-invalid': _ctx.v$.user.gender.$error })
                              }, " Please enter your gender ", 2))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["form-control", 
                      _ctx.v$.user.relationship.$error ? 'is-invalid' : 'input-text'
                    ]),
                        id: "relationship",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.user.relationship) = $event)),
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.hideErrors('relationship')))
                      }, [
                        _hoisted_40,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relationShipData, (relation) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: relation.relationshipId,
                            value: relation.relationshipId
                          }, _toDisplayString(relation.relationshipName), 9, _hoisted_41))
                        }), 128))
                      ], 34), [
                        [_vModelSelect, _ctx.user.relationship]
                      ])
                    ]),
                    (_ctx.v$.user.relationship.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          (_ctx.v$.user.relationship.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass({ 'is-invalid': _ctx.v$.user.relationship.$error })
                              }, " Please enter your relationship ", 2))
                            : (_ctx.v$.user.relationship.checkBenefit.$invalid)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: _normalizeClass({ 'is-invalid': _ctx.v$.user.relationship.$error })
                                }, _toDisplayString(_ctx.messages.benefitRelationError), 3))
                              : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn text-primary me-sm-3",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, " CANCEL "),
                _createElementVNode("button", {
                  type: "button",
                  id: "modify-button",
                  disabled: _ctx.v$.user.$invalid || _ctx.isSubmitDisabled,
                  class: _normalizeClass(["btn btn-primary", [_ctx.buttonDesign()]]),
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveDependent && _ctx.saveDependent(...args)))
                }, _toDisplayString(_ctx.saveBtnName), 11, _hoisted_44)
              ])
            ])
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}